import moment from 'moment';
import { Map, List } from 'immutable';

export function isMarketAvailable(market) {
    // Market has been settled, don't show it if one hour has been passed since the settled time
    const state = market.get('state');
    return state !== 'settled' && state !== 'new';
}

export function updateEventsAndMarkets(events, markets) {
    const availableMarketIds = [];

    const filteredMarkets = markets.get('items', Map()).filter(market => {
        const isAvailable = isMarketAvailable(market);

        if (isAvailable) {
            availableMarketIds.push(market.get('id'));
        }

        return isAvailable;
    });

    const updatedEvents = events.map(event => {
        const eventMarkets = event.get('markets', List()).filter(marketId => availableMarketIds.indexOf(marketId) !== -1) || List();

        return event.set('markets', eventMarkets);
    }).filter(event => event.get('markets', List()).size > 0);

    return {
        updatedEvents: updatedEvents,
        updatedMarkets: filteredMarkets
    };
}

export function getSportStartTime(sport) {
    let starTime;
    const startOfDay = moment().startOf('day');

    switch (sport) {
    case 'cricket':
        starTime = startOfDay.subtract(6, 'days').toISOString();
        break;

    case 'snooker':
        starTime = startOfDay.subtract(2, 'days').toISOString();
        break;

    case 'tennis':
        starTime = startOfDay.subtract(2, 'days').toISOString();
        break;

    case 'golf':
        starTime = startOfDay.subtract(5, 'days').toISOString();
        break;

    case 'horseracing':
    case 'greyhoundracing':
        starTime = moment().subtract( 6, 'hours' ).isSame( moment(), 'day' ) ?
            startOfDay.toISOString() :
            startOfDay.subtract( 6, 'hours' ).toISOString();
        break;

    default:
        starTime = startOfDay.subtract(12, 'hours').toISOString();
        break;
    }

    return starTime;
}
